import {useEffect, useState,} from "react";
import {convertToEuropeanFormat, formatDateTimeForInput} from "../../logics/helpers";
import {IDetailTransaction} from "../../utils/interfaces/IDetailTransaction";
import {AiOutlineCheck} from "react-icons/ai"
import {ImHourGlass} from "react-icons/im";
import {IDetailRebound} from "../../utils/interfaces/IDetailRebound";
import {BsInfoCircle} from "react-icons/bs";
import {motion} from "framer-motion";
import {modalVariants} from "./ui/ModalVariant";
import DetailsTransactionList from "./DetailsTransactionList";

interface Props {
    obj: IDetailRebound,
}

function DetailsReboundRow({obj: initialObj}: Props) {
    const [obj, setObj] = useState<IDetailRebound>(initialObj)
    const [isModalOpen, setIsModalOpen] = useState(false)

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <td className="mycia_td">
                {obj.id}
            </td>
            <td className="mycia_td">
                <span className="mr-1 ml-5">{convertToEuropeanFormat(obj.date)}</span>
            </td>
            <td className="mycia_td">
                <span className="mr-1">{obj.rebound_total_amount_to_invoice.toFixed(2)}</span>
                <span>€</span>
            </td>

            <td className="mycia_td" onClick={() => setIsModalOpen(true)}>
                {!isModalOpen ? <BsInfoCircle className={'ml-[16px] text-[20px] text-mcia_orange'}/> :
                    <BsInfoCircle color='transparent'/>}
            </td>

            <td className="mycia_td">
                {!isModalOpen ? <BsInfoCircle color='transparent'/>
                    : <motion.div
                        className=""
                        initial="hidden"
                        animate="visible"
                        variants={modalVariants}
                    >
                        <div className="">
                            <DetailsTransactionList detail_transactions={obj.rebounded_transactions}
                                                    onClose={() => setIsModalOpen(false)}
                            />
                        </div>
                    </motion.div>}
            </td>
        </>

    )
}

export default DetailsReboundRow;